import { themeColors } from '../../../../themeColors';
/**
 * @file  src\components\Onboarding\UserRegister\AgentInfoModal.js
 * @brief  This file is responsible for adding agent details
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import TextArea from "../../../Common/TextArea";
import { FormLabel } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import TextBox from "../../../Common/TextBox";
import BackBtn from "../../../../images/v2/back-btn.svg";
import AddIcon from "../../../../images/v2/Add-icon.svg";
import {
  handleTextBoxChange,
  capitalizeString,
} from "../../../../actions/common";
import {
  capitalizeFirstString,
  upperCaseEachSentenceFirst,
  getFileType,
  toTitleCase,
  getLocalStorage,
  trimString,
  formatPhoneNumber,
  removeLocalStorage,
} from "../../../../helpers/common";
import {
  alphaNumericValidation,
  textValidations,
  nameValidation,
  phoneNumberValidation,
  licenseValidation,
} from "../../../../helpers/validations";
import {
  AGENT_USER_FREE_PLAN,
  BIO_MAX_COUNT,
  ERROR_TEXT,
  TESTIMONIAL_MAX_COUNT,
} from "../../../../constants/common";
import PremiumPlanModal from "../../../PlanUpgrade/PremiumPlanModal";
import { fetchUserDetails } from "../../../../actions/userprofile";
import { USER_INFO_KEY } from "../../../../constants/common";
import Loader from "../../../Common/Loader";
import { getAgentDetails } from "../../../../services/agentClientsService";
import { getGeoLocation } from "../../../../services/commonServices";

const AgentInfoModal = (props) => {
  const dispatch = useDispatch();
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const userId = _.get(sessionData, "userInfo.userId", "");
  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );
  const [userDetails, setUserDetails] = useState(null);
  const [location, setLocation] = useState("");
  const [locationError, setLocationError] = useState("");
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFNError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLNError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [company, setCompany] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [license, setLicense] = useState("");
  const [licenseError, setLicenseError] = useState("");
  const [bio, setBio] = useState("");
  const [bioError, setBioError] = useState("");
  const [bioCount, setBioCount] = useState(0);
  const [imgError, setImgError] = useState("");
  const [reload, setReload] = useState(0);
  const supportedImageFormats = ["jpg", "jpeg", "png"];
  const { show, saveAgentDetails, UserId } = props;
  const [isUploading, setIsUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);
  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);
  const [bioCursorPos, setBioCursorPos] = useState(0);
  const bioRef = useRef();
  const locationString = getLocalStorage("LocationString");
  const [locationList, setLocationList] = useState([]);
  const [formattedAddress, setFormattedAddress] = useState();
  const [logoUrl, setLogoUrl] = useState("");
  const [logoError, setLogoError] = useState("");
  const [clientTestimonial, setTestimonials] = useState([]);
  const [testimonialCounts, setTestimonialCounts] = useState([0]);
  const [facebookUrl, setFacebookUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [websiteUrlError, setWebsiteUrlError] = useState(false);
  const [youtubeUrlError, setYoutubeUrlError] = useState(false);

  const [facebookUrlError, setFacebookUrlError] = useState(false);
  const [instagramUrlError, setInstagramUrlError] = useState(false);
  useEffect(() => {
    setImageUrl(props?.uploadedImageUrl);
  }, [props?.uploadedImageUrl, props?.reRenderEditProfileModel]);

  useEffect(() => {
    setLogoUrl(
      props?.uploadedLogoUrl ? props?.uploadedLogoUrl : userDetails?.logoUrl,
    );
  }, [props?.uploadedLogoUrl, props?.reRenderEditProfileModel]);

  const renderTooltip = (params) => (
    <Tooltip id="button-tooltip" {...params}>
      {params}
    </Tooltip>
  );

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserDetails());
    }
  }, [reload, userId]);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[userDetailsFromStore?.length - 1]);
    }
  }, [userDetailsFromStore]);

  useEffect(() => {
    if (userId) {
      getAgentInfo(userId);
    }
  }, []);
  /**
   * To get agent details
   * @param {*} userId
   */
  const getAgentInfo = async (userId) => {
    await getAgentDetails().then((response) => {
      if (response) {
        const result = _.get(response, "result[0]", null);
        setLocation(_.get(result, "Location", null));
        setCompany(_.get(result, "Company", null));
        setLicense(_.get(result, "LicenseNo", null));
        setImageUrl(_.get(result, "Img", ""));
        setLogoUrl(_.get(result, "logoUrl", ""));
        setFirstName(_.get(result, "FirstName", null));
        setLastName(_.get(result, "LastName", null));
        setBio(_.get(result, "Bio", null));
        setPhone(_.get(result, "Phone", null));
        setFacebookUrl(_.get(result, "facebookUrl", ""));
        setInstagramUrl(_.get(result, "instagramUrl", ""));
        setWebsiteUrl(_.get(result, "websiteUrl", ""));
        setYoutubeUrl(_.get(result, "youtubeUrl", ""));
        setTestimonials(_.get(result, "clientTestimonial", [""]));
      }
    });
  };
  /**
   * To handle location field changes
   * @param {*} value
   */
  // const handleLocationChange = (value) => {
  //   setLocationError("");
  //   setLocation(value);
  //   const trimmedValue = value.trim();
  //   if (trimmedValue === "") {
  //     setLocationError("Enter Location");
  //   } else if (
  //     !/^[a-zA-Z0-9& ]+$/.test(trimmedValue) ||
  //     /^[0-9&]+$/.test(trimmedValue)
  //   ) {
  //     setLocationError("Invalid input");
  //   }
  // };

  const getAddresseDetails = async ({ eventType, reqPayload }) => {
    await getGeoLocation(reqPayload).then((data) => {
      const results = _.get(data, "results");
      if (results?.length > 0) {
        const formatted_address = _.get(results?.[0], "formatted_address", "");
        if (results?.length > 0 && formatted_address !== "United States") {
          if (locationString) {
            handleItemSelection(results[0]);
            removeLocalStorage("LocationString");
          } else {
            setLocationList(results);
          }
        }
      }
    });
  };

  const clearAddressList = () => {
    setLocationList([]);
  };

  const handleLocationChange = (val) => {
    const value = capitalizeString(val);
    const reqPayload = `address=${value}&components=country:US`;
    if (value.trim() !== "") {
      getAddresseDetails({ reqPayload: reqPayload });
    } else {
      clearAddressList();
    }
    if (value && value.trim() !== "") {
      setLocation(value);
    } else {
      setLocation(value);
    }
  };

  const handleItemSelection = async (address) => {
    let city, state, county;
    removeLocalStorage("searchedLocation");
    const geometry = _.get(address, "geometry", "");
    const locBounds = _.get(geometry, "location", "");
    const formatted_address = _.get(address, "formatted_address", "");
    const firstAddressComponent = _.get(address, "address_components", "");
    const stateSearched = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "administrative_area_level_1";
    });
    if (stateSearched.length) {
      state = _.get(stateSearched?.[0], "short_name", "");
    }
    const locality = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "locality";
    });
    if (locality.length) {
      city = _.get(locality?.[0], "long_name", "");
    }
    const countyList = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "administrative_area_level_2";
    });

    if (countyList.length) {
      county = _.get(countyList?.[0], "short_name", "");
    }
    if (city != undefined) {
      setFormattedAddress(city + ", " + state);
    } else {
      setFormattedAddress(formatted_address);
    }
    setLocation(city != undefined ? city + ", " + state : formatted_address);
    clearAddressList();
  };

  /**
   * To handle firstname field changes
   * @param {*} e
   */
  const handleFirstNameChange = (e) => {
    setFNError("");
    const value = e.target.value;
    setFirstName(value);
    if (value.trim() === "") {
      setFNError("Enter First Name");
    } else if (!nameValidation(value.trim())) {
      setFNError("Invalid input");
    }
  };

  /**
   * To handle last name field changes
   * @param {*} e
   */
  const handleLastNameChange = (e) => {
    setLNError("");
    const value = e.target.value;
    setLastName(value);
    if (value.trim() === "") {
      setLNError("Enter Last Name");
    } else if (!nameValidation(value.trim())) {
      setLNError("Invalid input");
    }
  };

  /**
   * To handle ohone number field changes
   * @param {*} e
   */
  const handlePhone = (value) => {
    setPhoneError("");
    if (trimString(value) !== "") {
      value = formatPhoneNumber(value);
      setPhone(value);
    } else {
      setPhoneError("Enter Phone Number");
      setPhone("");
    }
  };

  /**
   * To handle phone number validation
   */
  const validatePhoneNumber = () => {
    setPhoneError("");
    if (trimString(phone) !== "") {
      if (!phoneNumberValidation(phone.trim())) {
        setPhoneError("Enter Valid Phone Number");
      }
    } else {
      setPhoneError("Enter Phone Number");
      setPhone("");
    }
  };

  /**
   * To handle company field changes
   * @param {*} value
   */
  const handleCompany = (value) => {
    setCompanyError("");
    setCompany(value);
    const trimmedValue = value.trim();
    if (trimmedValue === "") {
      setCompanyError("Enter Company");
    } else if (
      !/^[a-zA-Z0-9& ]+$/.test(trimmedValue) ||
      /^[0-9&]+$/.test(trimmedValue)
    ) {
      setCompanyError("Invalid input");
    }
  };

  /**
   * To handle license field changes
   * @param {*} value
   */
  const handleLicenseChange = (value) => {
    setLicenseError("");
    setLicense(value);
    const trimmedValue = value.trim();
    if (trimmedValue === "") {
      setLicenseError("Enter License Number");
    } else if (!licenseValidation(trimmedValue)) {
      //V2 change for license validation
      setLicenseError("Invalid input");
    }
  };

  const handleUrlChange = (url, type) => {
    const trimmedUrl = url?.trim() || ""; // Ensure it's a string
    const websiteUrlRegex =
      /^(https?:\/\/)?([\w\-]+\.)+[\w]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

    // Allow empty value, but validate only when there is input
    const isValid = trimmedUrl === "" || websiteUrlRegex.test(trimmedUrl);

    switch (type) {
      case "facebook":
        setFacebookUrl(trimmedUrl);
        setFacebookUrlError(trimmedUrl !== "" && !isValid); // Error only if input is invalid
        break;
      case "instagram":
        setInstagramUrl(trimmedUrl);
        setInstagramUrlError(trimmedUrl !== "" && !isValid);
        break;
      case "website":
        setWebsiteUrl(trimmedUrl);
        setWebsiteUrlError(trimmedUrl !== "" && !isValid);
        break;
      default:
        break;
    }
  };

  const handleYoutubeUrl = (url) => {
    const trimmedUrl = url.trim();
    setYoutubeUrl(trimmedUrl);
    setYoutubeUrlError(
      trimmedUrl === "" ? false : !validateYoutubeUrl(trimmedUrl),
    );
  };

  const validateYoutubeUrl = (url) => {
    const youtubeRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)$/;
    return youtubeRegex.test(url);
  };

  useEffect(() => {
    if (bioRef.current) {
      bioRef.current.setSelectionRange(bioCursorPos, bioCursorPos);
    }
  }, [bioCursorPos]);

  /**
   * To handle bio field changes
   * @param {*} e
   */
  const handleBioChange = (e) => {
    setBioError("");
    const _bio = handleTextBoxChange(e);
    if (!textValidations(_bio)) {
      setBioError(ERROR_TEXT);
    }
    let value = capitalizeFirstString(_bio);
    value = upperCaseEachSentenceFirst(value);
    if (trimString(value) != "") {
      setBioCursorPos(e.target.selectionStart);
    }

    setBioCount(value.length);
    setBio(value);
  };

  const handleTestimonial = (e, index) => {
    const value = e.target.value;
    setTestimonials((prevTestimonials) =>
      prevTestimonials.map((testimonial, i) =>
        i === index ? value : testimonial,
      ),
    );
    setTestimonialCounts((prevCounts) =>
      prevCounts.map((count, i) => (i === index ? value.length : count)),
    );
  };

  const addTestimonial = () => {
    setTestimonials((prevTestimonials) => [...prevTestimonials, ""]);
    setTestimonialCounts((prevCounts) => [...prevCounts, 0]);
  };

  const updateReloadParam = () => {
    setReload(reload + 1);
  };

  /**
   * To handle image upload
   * @param {*} e
   */
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    const selectedFileType = getFileType(_.get(e.target.files[0], "name"));
    let isValid = true;
    if (!_.includes(supportedImageFormats, selectedFileType)) {
      isValid = false;
      setImgError("Select Valid Image");
    }
    if (isValid) {
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          props.onClickChangePhoto(reader.result);
        };
        reader.readAsDataURL(file);
        // Reset the file input
        e.target.value = null;
      }
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    const selectedFileType = getFileType(_.get(e.target.files[0], "name"));
    let isValid = true;
    if (!_.includes(supportedImageFormats, selectedFileType)) {
      isValid = false;
      setLogoError("Select Valid Logo");
    }
    if (isValid) {
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          props.onClickChangePhoto(reader.result, true);
        };
        reader.readAsDataURL(file);
        // Reset the file input
        e.target.value = null;
      }
    }
  };

  /**
   * To handle validation
   * @returns
   */
  const checkValid = () => {
    if (userDetails?.PlanName != AGENT_USER_FREE_PLAN) {
      if (location && license && company && firstName && lastName && phone) {
        if (
          locationError ||
          licenseError ||
          companyError ||
          firstNameError ||
          lastNameError ||
          phoneError
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    } else {
      if (location && license && company && firstName && lastName) {
        if (
          locationError ||
          licenseError ||
          companyError ||
          firstNameError ||
          lastNameError ||
          websiteUrlError ||
          youtubeUrlError
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    }
  };
  const agentInfo = {
    location: location,
    company: company,
    licenseNo: license,
    bio: bio,
    img: imageUrl || "",
    plan: 0,
    firstName: firstName,
    lastName: lastName,
    phone: phone,
    logoUrl: logoUrl || "",
    facebookUrl: facebookUrl,
    instagramUrl: instagramUrl,
    websiteUrl: websiteUrl,
    youtubeUrl: youtubeUrl,
    clientTestimonial: clientTestimonial,
  };
  return (
    <>
      {isUploading ? <Loader /> : ""}
      <Modal
        show={show}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        className="modal-custom-width"
      >
        <Modal.Body className="agent-info-modal">
          {/* <div className="d-flex align-items-center pointer">
            <img src={BackBtn} alt="back-btn"></img>
            <span className="back-btn ms-1">Back</span>
          </div> */}
          <h3 className="agent-modal-head">
            Complete your profile to start posting
          </h3>

          <Row>
            <Col xl={12}>
              <p className="agent-info-para">
                These details will be shown to other members just like the MLS.
                Non-members will see your profile once you exchange an
                introduction/message. Make sure everything is accurate.
              </p>
              {userDetails?.PlanName === AGENT_USER_FREE_PLAN && (
                <div className="view-plans-wrap mb-4">
                  <p>
                    Want to add a photo and bio to your agent profile?{" "}
                    <span className="f-bold plans-text-color">
                      Upgrade your Premium
                    </span>{" "}
                    and gain access to exclusive professional features.
                  </p>

                  <Button
                    variant="primary"
                    className="btn d-flex"
                    onClick={() => PremiumPlanModalShow()}
                  >
                    <span className="">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.47 7.88843C11.4711 8.06681 11.4169 8.24115 11.3149 8.38746C11.2128 8.53378 11.0679 8.64487 10.9002 8.70546L8.07554 9.74452L7.03648 12.5669C6.97495 12.7341 6.86362 12.8784 6.71752 12.9803C6.57142 13.0822 6.39758 13.1368 6.21945 13.1368C6.04132 13.1368 5.86748 13.0822 5.72138 12.9803C5.57528 12.8784 5.46395 12.7341 5.40242 12.5669L4.36062 9.7478L1.53765 8.70874C1.37049 8.64721 1.22622 8.53588 1.12432 8.38978C1.02241 8.24368 0.967773 8.06984 0.967773 7.89171C0.967773 7.71358 1.02241 7.53974 1.12432 7.39364C1.22622 7.24754 1.37049 7.13621 1.53765 7.07468L4.36226 6.03562L5.40132 3.21319C5.46286 3.04603 5.57418 2.90176 5.72028 2.79986C5.86638 2.69795 6.04023 2.64331 6.21836 2.64331C6.39649 2.64331 6.57033 2.69795 6.71643 2.79986C6.86253 2.90176 6.97386 3.04603 7.03539 3.21319L8.07445 6.0378L10.8969 7.07687C11.0644 7.1366 11.2094 7.24662 11.3119 7.3919C11.4145 7.53717 11.4697 7.71058 11.47 7.88843ZM8.4075 2.63843H9.2825V3.51343C9.2825 3.62946 9.32859 3.74074 9.41064 3.82279C9.49268 3.90483 9.60396 3.95093 9.72 3.95093C9.83603 3.95093 9.94731 3.90483 10.0294 3.82279C10.1114 3.74074 10.1575 3.62946 10.1575 3.51343V2.63843H11.0325C11.1485 2.63843 11.2598 2.59233 11.3419 2.51029C11.4239 2.42824 11.47 2.31696 11.47 2.20093C11.47 2.0849 11.4239 1.97362 11.3419 1.89157C11.2598 1.80952 11.1485 1.76343 11.0325 1.76343H10.1575V0.888428C10.1575 0.772395 10.1114 0.661116 10.0294 0.579068C9.94731 0.497021 9.83603 0.450928 9.72 0.450928C9.60396 0.450928 9.49268 0.497021 9.41064 0.579068C9.32859 0.661116 9.2825 0.772395 9.2825 0.888428V1.76343H8.4075C8.29146 1.76343 8.18018 1.80952 8.09814 1.89157C8.01609 1.97362 7.97 2.0849 7.97 2.20093C7.97 2.31696 8.01609 2.42824 8.09814 2.51029C8.18018 2.59233 8.29146 2.63843 8.4075 2.63843ZM13.22 4.38843H12.7825V3.95093C12.7825 3.8349 12.7364 3.72362 12.6544 3.64157C12.5723 3.55952 12.461 3.51343 12.345 3.51343C12.229 3.51343 12.1177 3.55952 12.0356 3.64157C11.9536 3.72362 11.9075 3.8349 11.9075 3.95093V4.38843H11.47C11.354 4.38843 11.2427 4.43452 11.1606 4.51657C11.0786 4.59862 11.0325 4.7099 11.0325 4.82593C11.0325 4.94196 11.0786 5.05324 11.1606 5.13529C11.2427 5.21733 11.354 5.26343 11.47 5.26343H11.9075V5.70093C11.9075 5.81696 11.9536 5.92824 12.0356 6.01029C12.1177 6.09233 12.229 6.13843 12.345 6.13843C12.461 6.13843 12.5723 6.09233 12.6544 6.01029C12.7364 5.92824 12.7825 5.81696 12.7825 5.70093V5.26343H13.22C13.336 5.26343 13.4473 5.21733 13.5294 5.13529C13.6114 5.05324 13.6575 4.94196 13.6575 4.82593C13.6575 4.7099 13.6114 4.59862 13.5294 4.51657C13.4473 4.43452 13.336 4.38843 13.22 4.38843Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                    View plans
                  </Button>
                </div>
              )}

              <div className="d-flex align-items-center mb-4">
                <div className="prof-img mr-12">
                  {imageUrl !== "" && imageUrl !== null ? (
                    <img src={imageUrl + "?" + Math.random().toString(36)} />
                  ) : (
                    <svg
                      width="24"
                      height="23"
                      viewBox="0 0 24 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.3643 21.1875C21.7317 18.375 19.1183 16.264 16.0253 15.2594C17.5078 14.3778 18.6599 13.0338 19.3046 11.4339C19.9493 9.83406 20.0508 8.06678 19.5937 6.40358C19.1365 4.74039 18.146 3.27329 16.7741 2.22766C15.4023 1.18204 13.7252 0.615723 12.0003 0.615723C10.2754 0.615723 8.59824 1.18204 7.22643 2.22766C5.85462 3.27329 4.86405 4.74039 4.4069 6.40358C3.94975 8.06678 4.05131 9.83406 4.69597 11.4339C5.34063 13.0338 6.49273 14.3778 7.97529 15.2594C4.88227 16.264 2.2689 18.375 0.636225 21.1875C0.556066 21.3194 0.513672 21.4707 0.513672 21.625C0.513672 21.7793 0.556066 21.9307 0.636225 22.0625C0.711012 22.1966 0.820597 22.308 0.953423 22.385C1.08625 22.462 1.23739 22.5018 1.39091 22.5H22.6097C22.7632 22.5018 22.9143 22.462 23.0472 22.385C23.18 22.308 23.2896 22.1966 23.3643 22.0625C23.4445 21.9307 23.4869 21.7793 23.4869 21.625C23.4869 21.4707 23.4445 21.3194 23.3643 21.1875Z"
                        fill={themeColors.neutral450}
                      />
                    </svg>
                  )}
                </div>
                <div className="upload-btn-outerwrap d-flex align-items-baseline">
                  <div className="upload-btn-innerwrap me-1 position-relative">
                    <input
                      disabled={
                        userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                          ? false
                          : true
                      }
                      type="file"
                      name="profileImage"
                      id="profileImage"
                      className=""
                      onChange={(e) => handleImageUpload(e)}
                    />
                    <label
                      htmlFor="profileImage"
                      className={
                        userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                          ? "active agent-user-btn"
                          : "disabled-label"
                      }
                    >
                      {imageUrl !== "" && imageUrl !== null
                        ? "Replace Profile Image"
                        : "Add Profile Image"}
                    </label>
                    <span className="error-msg w-125 h-auto">{imgError}</span>
                  </div>
                  {userDetails?.PlanName === AGENT_USER_FREE_PLAN && (
                    <div className="pro-badge mt-2 mt-sm-2">pro</div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="addyour-property-details-wrap mb-12 col-md-6 agent-info-textfield pe-2">
                  <label className="agent-modal-label">
                    First name <span>*</span>
                  </label>

                  <TextBox
                    name="firstName"
                    type="text"
                    errorMessage={firstNameError}
                    value={toTitleCase(firstName)}
                    placeholder="First name"
                    className={firstNameError && "validation-txtfld"}
                    errorClass="error-validation-msg"
                    onChange={(e) => {
                      handleFirstNameChange(e);
                    }}
                  />
                  <div className="error-msg"></div>
                </div>
                <div className="addyour-property-details-wrap mb-12 col-md-6 agent-info-textfield ps-2">
                  <label className="agent-modal-label">
                    Last name <span>*</span>
                  </label>

                  <TextBox
                    name="lastName"
                    type="text"
                    className={lastNameError && "validation-txtfld"}
                    errorMessage={lastNameError}
                    value={toTitleCase(lastName)}
                    placeholder="Last name"
                    errorClass="error-validation-msg"
                    onChange={(e) => {
                      handleLastNameChange(e);
                    }}
                  />
                  <div className="error-msg"></div>
                </div>
              </div>
              <div className="addyour-property-details-wrap mb-12 agent-info-textfield">
                <label className="agent-modal-label">
                  <div className="d-flex align-items-center">
                    <span>Phone Number</span>
                    {userDetails?.PlanName === AGENT_USER_FREE_PLAN ? (
                      <div className="pro-badge d-inline-flex align-items-center ms-1">
                        Pro
                      </div>
                    ) : (
                      <span> *</span>
                    )}
                  </div>
                </label>

                <TextBox
                  disabled={
                    userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                      ? false
                      : true
                  }
                  name="phone"
                  type="text"
                  value={phone}
                  placeholder="Phone number"
                  errorClass="error-validation-msg"
                  onChange={(e) => handlePhone(e.target.value)}
                  onBlur={() => {
                    validatePhoneNumber();
                  }}
                  errorMessage={phoneError}
                  className={phoneError && "validation-txtfld"}
                  maxLength={14}
                />
                <div className="error-msg"></div>
              </div>
              <div className="addyour-property-details-wrap mb-12 agent-info-textfield">
                <label className="agent-modal-label">
                  Location <span>*</span>
                </label>

                <TextBox
                  name="location"
                  type="text"
                  className={locationError && "validation-txtfld"}
                  errorMessage={locationError}
                  value={toTitleCase(location)}
                  placeholder="City, State"
                  errorClass="error-validation-msg"
                  onChange={(e) => {
                    handleLocationChange(e.target.value);
                  }}
                  maxLength={40}
                />
                <div className="error-msg"></div>
                {locationList.length > 0 ? (
                  <div className="location-result-wrap mw-100 mt-4">
                    <ul>
                      {locationList?.map((address, i) => {
                        return (
                          <li key={i}>
                            <a
                              role="button"
                              href={void 0}
                              onClick={(e) => {
                                handleItemSelection(address);
                              }}
                            >
                              {_.get(address, "formatted_address", "")}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="addyour-property-details-wrap mb-12 agent-info-textfield">
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip("Company name")}
                >
                  <span className="price-info-icon">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </OverlayTrigger>

                <label className="agent-modal-label">
                  Company <span>*</span>
                </label>

                <TextBox
                  name="company"
                  type="text"
                  value={toTitleCase(company)}
                  placeholder="Company name"
                  errorClass="error-validation-msg"
                  onChange={(e) => handleCompany(e.target.value)}
                  errorMessage={companyError}
                  className={companyError && "validation-txtfld"}
                  maxLength={50}
                />
                <div className="error-msg"></div>
              </div>

              <div className="upload-btn-innerwrap addyour-property-details-wrap mb-12">
                <label
                  htmlFor="logoUrl"
                  className={`active agent-user-btn ${userDetails?.PlanName === AGENT_USER_FREE_PLAN ? "disabled" : ""}`}
                >
                  Add Logo
                </label>
                <input
                  type="file"
                  name="logoUrl"
                  id="logoUrl"
                  onChange={(e) => handleLogoUpload(e)}
                  className=" "
                  disabled={userDetails?.PlanName === AGENT_USER_FREE_PLAN}
                />
                {userDetails?.PlanName === AGENT_USER_FREE_PLAN ? (
                  <div className="pro-badge d-inline-flex align-items-center ms-1">
                    Pro
                  </div>
                ) : null}
                <span className="error-msg w-104 h-auto error-wordbreak">
                  {logoError}
                </span>
              </div>

              <div className="addyour-property-details-wrap mb-12 agent-info-textfield">
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip("Company license")}
                >
                  <span className="price-info-icon">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </OverlayTrigger>

                <label className="agent-modal-label">
                  License number <span>*</span>
                </label>

                <TextBox
                  name="company"
                  type="text"
                  errorMessage={licenseError}
                  className={licenseError && "validation-txtfld"}
                  value={toTitleCase(license)}
                  placeholder="License number"
                  errorClass="error-validation-msg"
                  onChange={(e) => handleLicenseChange(e.target.value)}
                  maxLength={40}
                />
                <div className="error-msg"></div>
              </div>

              <div className="wantad-des-wrap bio-tarea-wrap agent-info-textfield">
                <div className="position-relative agent-info-textfield">
                  <FormLabel className="d-inline-block label-l-spacing">
                    <div className="d-flex align-items-center">
                      <span className="agent-modal-label">Bio</span>{" "}
                      {userDetails?.PlanName === AGENT_USER_FREE_PLAN && (
                        <div className="pro-badge d-inline-flex align-items-center ms-1">
                          pro
                        </div>
                      )}
                    </div>
                  </FormLabel>
                  <TextArea
                    disabled={
                      userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                        ? false
                        : true
                    }
                    className="form-control txt-area bio-tarea-style"
                    errorMessage={bioError}
                    maxLength={2500}
                    value={bio ? bio : ""}
                    placeholder="A few sentences about yourself..."
                    onChange={(e) => {
                      handleBioChange(e);
                    }}
                    txtRef={bioRef}
                  />
                  <div className="des-count mb-4">
                    <span>{bioCount}</span>/<span>{BIO_MAX_COUNT}</span>
                  </div>
                </div>
              </div>
              <div className="wantad-des-wrap bio-tarea-wrap agent-info-textfield">
                <div className="position-relative">
                  {/* <FormLabel className="d-inline-block label-l-spacing">
                    <span className="agent-modal-label">
                      Client Testimonial (optional)
                    </span>{" "}
                    {userDetails?.PlanName === AGENT_USER_FREE_PLAN && (
                      <div className="pro-badge d-inline-flex align-items-center ms-1">
                        pro
                      </div>
                    )}
                  </FormLabel> */}
                  {Array.isArray(clientTestimonial) &&
                    clientTestimonial.map((testimonial, index) => (
                      <div key={index}>
                        <FormLabel className="d-flex align-items-center label-l-spacing">
                          <span className="agent-modal-label">
                            Client Testimonial (optional)
                          </span>{" "}
                          {userDetails?.PlanName === AGENT_USER_FREE_PLAN && (
                            <div className="pro-badge d-inline-flex align-items-center ms-1">
                              pro
                            </div>
                          )}
                        </FormLabel>
                        <TextArea
                          disabled={
                            userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                              ? false
                              : true
                          }
                          className="form-control txt-area bio-tarea-style"
                          // errorMessage={bioError}
                          maxLength={1000}
                          value={testimonial}
                          placeholder="What your clients think..."
                          onChange={(e) => {
                            handleTestimonial(e, index);
                          }}
                        />
                        <div className="des-count mb-4">
                          <span>{testimonialCounts[index]}</span>/
                          <span>{TESTIMONIAL_MAX_COUNT}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              <div
                className="d-flex align-items-center add-testimonial-btn"
                onClick={() => {
                  userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                    ? addTestimonial()
                    : null;
                }}
              >
                <img src={AddIcon} alt="add-icon"></img>
                <button className="add-another-testimonial">
                  Add another testimonial
                </button>
              </div>

              <div className="addyour-property-details-wrap agent-info-textfield mb-12">
                <label className="agent-modal-label">
                  <div className="d-flex align-items-center">
                    <span>Facebook Profile (optional)</span>
                    {userDetails?.PlanName === AGENT_USER_FREE_PLAN && (
                      <div className="pro-badge d-inline-flex align-items-center ms-1">
                        pro
                      </div>
                    )}
                  </div>
                </label>

                <TextBox
                  disabled={
                    userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                      ? false
                      : true
                  }
                  id="facebookUrl"
                  name="facebookUrl"
                  type="text"
                  value={facebookUrl}
                  placeholder="Paste link to profile here"
                  className="form-control"
                  onChange={(e) => handleUrlChange(e.target.value, "facebook")}
                  errorClass="error-validation-msg"
                  errorMessage={facebookUrlError ? "Enter Valid URl" : ""}
                  // errorMessage={firstNameError}
                />
                <div className="error-msg"></div>
              </div>
              <div className="addyour-property-details-wrap agent-info-textfield mb-12">
                <label className="agent-modal-label">
                  <div className="d-flex align-items-center">
                    <span>Instagram Profile (optional)</span>
                    {userDetails?.PlanName === AGENT_USER_FREE_PLAN && (
                      <div className="pro-badge d-inline-flex align-items-center ms-1">
                        pro
                      </div>
                    )}
                  </div>
                </label>

                <TextBox
                  disabled={
                    userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                      ? false
                      : true
                  }
                  id="instagramUrl"
                  name="instagramUrl"
                  value={instagramUrl}
                  type="text"
                  placeholder="Paste link to profile here"
                  className="form-control"
                  errorClass="error-validation-msg"
                  onChange={(e) => handleUrlChange(e.target.value, "instagram")}
                  errorMessage={instagramUrlError ? "Enter Valid URl" : ""}
                  // errorMessage={lastNameError}
                />
                <div className="error-msg"></div>
              </div>
              <div className="addyour-property-details-wrap agent-info-textfield mb-12">
                <label className="agent-modal-label">Website</label>
                <TextBox
                  id="websiteUrl"
                  name="websiteUrl"
                  type="url"
                  value={websiteUrl}
                  placeholder="Paste link to website here"
                  className="form-control"
                  onChange={(e) => handleUrlChange(e.target.value, "website")}
                  errorClass="error-validation-msg"
                  errorMessage={websiteUrlError ? "Enter Valid URl" : ""}
                  // errorMessage={firstNameError}
                />
              </div>
              <div className="addyour-property-details-wrap agent-info-textfield mb-12">
                <label className="agent-modal-label">
                  <div className="d-flex align-items-center">
                    <span>Youtube Video (optional)</span>
                    {userDetails?.PlanName === AGENT_USER_FREE_PLAN && (
                      <div className="pro-badge d-inline-flex align-items-center ms-1">
                        pro
                      </div>
                    )}
                  </div>
                </label>
                <TextBox
                  disabled={
                    userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                      ? false
                      : true
                  }
                  id="youtubeUrl"
                  name="youtubeUrl"
                  type="url"
                  value={youtubeUrl}
                  placeholder="Paste video embed link here"
                  className="form-control"
                  onChange={(e) => handleYoutubeUrl(e.target.value)}
                  errorClass="error-validation-msg"
                  errorMessage={
                    youtubeUrlError ? "Enter Valid Youtube URl" : ""
                  }
                  // errorMessage={firstNameError}
                /> 
              </div>

              <Button
                variant="primary"
                className="btn w-100 l-spacing-0"
                disabled={checkValid()}
                onClick={() => saveAgentDetails(agentInfo)}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <PremiumPlanModal
        userDetails={userDetails}
        updateReloadParam={updateReloadParam}
        show={showPremiumPlanModal}
        onHide={PremiumPlanModalClose}
        showPlanModal={PremiumPlanModalShow}
      />
    </>
  );
};
export default AgentInfoModal;
